import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/close.png'
import _imports_1 from '../assets/burger.png'
import _imports_2 from '../assets/trash.png'
import _imports_3 from '../assets/enter.png'


const _hoisted_1 = { class: "widget__settings" }
const _hoisted_2 = { class: "widget__settings-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Settings", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close settings"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "widget__settings-burger",
  src: _imports_1,
  alt: "burger-menu"
}, null, -1)
const _hoisted_8 = { class: "widget__settings-city-name" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "remove item"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "widget__settings-add-city" }
const _hoisted_13 = { for: "add" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Add city ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "add city"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "widget__settings-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showWidgetSettings')))
      }, _hoisted_5)
    ]),
    _createVNode(_component_draggable, {
      modelValue: _ctx.getCities,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getCities) = $event)),
      "item-key": "id"
    }, {
      item: _withCtx(({ element }) => [
        (_openBlock(), _createElementBlock("li", {
          class: "widget__settings-city-item",
          id: element.id,
          key: element.id
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(element.city), 1),
          _createElementVNode("button", {
            class: "widget__settings-city-remove",
            onClick: ($event: any) => (_ctx.$emit('removeCity', element.id))
          }, _hoisted_11, 8, _hoisted_9)
        ], 8, _hoisted_6))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("label", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          name: "add",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cityAdded) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.emitCityName && _ctx.emitCityName(...args)), ["enter"])),
          type: "text"
        }, null, 544), [
          [_vModelText, _ctx.cityAdded]
        ])
      ]),
      _createElementVNode("button", {
        class: "widget__settings-add-btn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.emitCityName && _ctx.emitCityName(...args)))
      }, _hoisted_16)
    ])
  ]))
}